import { render, staticRenderFns } from "./FileSection.vue?vue&type=template&id=139b92c8&"
import script from "./FileSection.vue?vue&type=script&lang=js&"
export * from "./FileSection.vue?vue&type=script&lang=js&"
import style0 from "./FileSection.vue?vue&type=style&index=0&id=139b92c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports